import React from 'react'

export const AbTesting = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M12 22h-1.25V2H12v20Zm-8.75-2.5v-15c0-.345.28-.625.625-.625h6.875c.345 0 .625.28.625.625v15c0 .345-.28.625-.625.625H3.875a.625.625 0 0 1-.625-.625Zm2.5-13.125a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0Zm0 1.875a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0Zm-1.25 10h5.625V17H4.5v1.25Zm0-2.5h5.625V14.5H4.5v1.25Zm0-2.5h5.625V12H4.5v1.25Z" />
        <path opacity=".6" d="M14.5 5.125v5h5v-5h-5Zm6.25-1.25v7.5h-7.5v-7.5h7.5Z" />
        <path opacity=".7" d="M13.25 12.625h7.5v7.5h-7.5v-7.5Z" />
    </svg>
)
export const Actions = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="m13.659 3-1.332 7.6h5.427l-6.849 10.306 1.577-7.649H7" />
    </svg>
)
export const Analytics = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path opacity=".5" d="M7.706 19.647a2.353 2.353 0 1 1-4.706 0v-5.882a2.353 2.353 0 1 1 4.706 0v5.882Z" />
        <path d="M14.766 19.647a2.353 2.353 0 1 1-4.706 0V4.353a2.353 2.353 0 1 1 4.706 0v15.294Z" />
        <path opacity=".75" d="M21.824 19.647a2.353 2.353 0 1 1-4.706 0v-9.412a2.353 2.353 0 1 1 4.706 0v9.412Z" />
    </svg>
)
export const Annotations = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M20 12a.889.889 0 0 1-.889.889h-4.966l3.514 3.508a.895.895 0 0 1-1.262 1.262l-3.508-3.514v4.966a.889.889 0 1 1-1.778 0v-4.966L7.603 17.66a.895.895 0 0 1-1.262-1.262l3.514-3.508H4.889a.889.889 0 1 1 0-1.778h4.966L6.34 7.603a.895.895 0 0 1 1.262-1.262l3.508 3.514V4.889a.889.889 0 1 1 1.778 0v4.966l3.508-3.514a.895.895 0 0 1 1.262 1.262l-3.514 3.508h4.966c.491 0 .889.398.889.889Z" />
    </svg>
)
export const API = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            d="M22 8.154H2v10A3.846 3.846 0 0 0 5.846 22h12.308A3.846 3.846 0 0 0 22 18.154v-10ZM6.817 11.775a.77.77 0 0 1 1.089-1.088l2.991 2.992c.3.3.3.787 0 1.087l-2.991 2.992a.77.77 0 1 1-1.089-1.088l2.448-2.448-2.448-2.447Zm7.49 4.071a.77.77 0 1 0 0 1.539h3.078a.769.769 0 1 0 0-1.539h-3.077Z"
            clipRule="evenodd"
        />
        <path
            fillRule="evenodd"
            d="M5.846 2A3.846 3.846 0 0 0 2 5.846v.77h20v-.77A3.846 3.846 0 0 0 18.154 2H5.846Z"
            clipRule="evenodd"
            opacity=".5"
        />
    </svg>
)
export const AppLibrary = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".8"
            d="M4.914 2h3.171C9.695 2 11 3.61 11 4.914v3.172a2.914 2.914 0 0 1-2.914 2.913H4.914C3.304 11 2 9.39 2 8.086V4.914A2.914 2.914 0 0 1 4.914 2Z"
        />
        <path
            opacity=".6"
            d="M4.914 13h3.171C9.695 13 11 14.61 11 15.916v3.171A2.914 2.914 0 0 1 8.085 22H4.914C3.304 22 2 20.39 2 19.086v-3.171A2.914 2.914 0 0 1 4.914 13Z"
        />
        <path
            opacity=".4"
            d="M15.914 13h3.171C20.695 13 22 14.61 22 15.916v3.171A2.914 2.914 0 0 1 19.085 22h-3.171C14.304 22 13 20.39 13 19.086v-3.171A2.914 2.914 0 0 1 15.914 13Z"
        />
        <path d="M13.999 7.5h2.5V10a1 1 0 0 0 2 0V7.5H21a1 1 0 0 0 0-2h-2.5V3a1 1 0 1 0-2 0v2.5H14a1 1 0 1 0 0 2Z" />
    </svg>
)

export const Bell = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        className={`fill-current ${className}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        {...other}
    >
        <path
            fillRule="evenodd"
            d="M18.578 17.677s.922-.075.922-1.107c0-1.033-2.192-3.585-2.192-3.585V8.474c0-1.757-1.405-2.874-3.192-3.352a2.277 2.277 0 1 0-4.232 0c-1.787.478-3.192 1.596-3.192 3.352v4.512S4.5 15.537 4.5 16.57c0 1.032.922 1.107.922 1.107h13.156ZM12 3.198a1.078 1.078 0 1 1 0 2.157 1.078 1.078 0 0 1 0-2.157Zm2.277 15.565c-.025 1.31-1.035 2.364-2.277 2.364-1.242 0-2.251-1.054-2.276-2.364h4.553Z"
            clipRule="evenodd"
        />
    </svg>
)

export const Bootstrapping = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M2.581 10.265a.59.59 0 0 0-.586.587v3.199a.587.587 0 0 0 .586.59h18.823a.588.588 0 0 0 .59-.59v-3.2a.589.589 0 0 0-.59-.586H2.58Zm.592 1.177h17.645v2.022l-17.645.001v-2.023Zm1.028.42a.587.587 0 1 0 0 1.178h8.476a.588.588 0 0 0 0-1.177H4.2Z" />
    </svg>
)
export const Cloud = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.605 11.24c-.103-2.886-2.886-4.844-5.617-4.07-2.576-3.864-8.604-2.267-8.81 2.421-4.843 1.34-3.915 8.657 1.186 8.657H18.42c4.07 0 4.946-5.771 1.186-7.007l-.001-.001Z"
        />
    </svg>
)
export const Cohorts = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M21 11.914A8.912 8.912 0 0 0 12.086 3v8.914H21Z" />
        <path
            opacity=".5"
            d="M18.945 13.085h-7.973V5.112a7.97 7.97 0 0 0-5.637 13.609 7.969 7.969 0 0 0 11.275 0 7.968 7.968 0 0 0 2.335-5.636Z"
        />
    </svg>
)
export const CorrelationAnalysis = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.884 18.884a1.25 1.25 0 0 1 0-1.768L16.116 5.884a1.25 1.25 0 0 1 1.768 1.768L6.652 18.884a1.25 1.25 0 0 1-1.768 0Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 6.25C8 5.56 8.56 5 9.25 5h8.5a1.25 1.25 0 1 1 0 2.5h-8.5C8.56 7.5 8 6.94 8 6.25Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.75 16c-.69 0-1.25-.56-1.25-1.25v-8.5a1.25 1.25 0 1 1 2.5 0v8.5c0 .69-.56 1.25-1.25 1.25Z"
        />
    </svg>
)
export const Dashboards = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            d="M14.668 7.36c-.884-.23-1.767-.36-2.684-.36C6.484 7 2 11.485 2 16.984c0 .294.262.556.556.556a.573.573 0 0 0 .556-.556c0-4.91 3.994-8.904 8.904-8.904.819 0 1.604.098 2.39.327.295.098.59-.098.688-.393.065-.261-.131-.59-.426-.654Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.676 7.365a.548.548 0 0 0-.687-.065c-.819.556-7.89 5.467-8.643 6.22-.95.949-.95 2.52 0 3.502a2.451 2.451 0 0 0 3.47 0l5.008-7.495c.176-.275.332-.526.465-.741.215-.347.371-.598.452-.7.164-.263.132-.557-.065-.72Zm-7.627 8.512a.544.544 0 0 0 .393-.164c.098-.132.164-.262.164-.393a.606.606 0 0 0-.164-.394c-.196-.196-.588-.196-.785 0a.602.602 0 0 0-.164.393c0 .132.065.295.163.394.099.099.229.164.393.164Z"
        />
        <path d="M20.888 16.826c0-2.422-1.036-4.68-2.738-6.35l.675-.949a9.904 9.904 0 0 1 3.175 7.3.573.573 0 0 1-.556.556.573.573 0 0 1-.556-.557Z" />
        <path
            opacity=".5"
            d="M12.54 9.88v-.556a.573.573 0 0 0-.556-.556.573.573 0 0 0-.556.556v.556c0 .294.261.556.556.556a.55.55 0 0 0 .556-.556ZM5.273 16.067a.573.573 0 0 0 .557-.556.573.573 0 0 0-.557-.557h-.556a.573.573 0 0 0-.556.556c0 .295.262.557.556.557h.556Z"
        />
        <path d="M19.283 16.067a.573.573 0 0 0 .556-.556.573.573 0 0 0-.556-.557h-.556a.573.573 0 0 0-.556.556c0 .295.262.557.556.557h.556Z" />
    </svg>
)
export const DataManagement = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 6.346C3 5.636 3.636 5 4.346 5h5.467c.754 0 1.53.458 1.79 1.19l.315.867v.007l.779 2.187a.172.172 0 0 0 .014.034l.004.004.01.01v.006l.006.004a.06.06 0 0 1 .007.003v.007a.071.071 0 0 0 .007.003l.007.004.004.004.01.01.006.003a.06.06 0 0 1 .007.003c.01.008.022.015.034.02a.22.22 0 0 0 .034.008h7.244c.294 0 .512.094.663.246a.753.753 0 0 1 .102.123.958.958 0 0 1 .144.574v7.4c0 .295-.095.511-.246.664-.151.151-.369.245-.663.245H3.91c-.294 0-.512-.094-.663-.245-.151-.153-.246-.37-.246-.663V6.346ZM8.941 17c.52 0 .941-.421.941-.941v-2.353a.941.941 0 1 0-1.882 0v2.353c0 .52.421.941.941.941Zm3.53-.823a.824.824 0 0 1-1.647 0v-5.354a.824.824 0 0 1 1.647 0v5.354Zm2.117.823c.52 0 .942-.421.942-.941v-3.765a.941.941 0 1 0-1.883 0v3.765c0 .52.422.941.941.941Z"
        />
        <path
            opacity=".5"
            d="m12.362 7.187.65 1.818h7.08c.046 0 .09.003.136.006.09.008.176.025.26.048.02.005.041.008.06.014.017.005.033.014.049.02.037.014.074.032.11.048.005.003.014.004.02.007.029.015.06.03.088.048l.014.007c.03.019.055.04.082.061.006.005.015.009.02.014.024.019.047.034.069.055v-.855c0-.718-.573-1.291-1.292-1.291h-7.346Z"
        />
    </svg>
)
export const DataWarehouse = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.05 17.077a.894.894 0 0 1-.891-.896c0-.494.399-.895.892-.895s.892.4.892.895-.4.896-.892.896Zm-3.577 0a.894.894 0 0 1-.893-.896.894.894 0 1 1 1.784 0c0 .495-.398.896-.891.896Zm16.06-3.623h.017a1.887 1.887 0 0 0-1.443-.673H3.891A1.897 1.897 0 0 0 2 14.678v3.006c0 1.046.848 1.897 1.891 1.897H20.09c1.042 0 1.89-.85 1.89-1.897v-3.006c0-.466-.168-.894-.447-1.224Z"
        />
        <path
            opacity=".7"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.844 11.848h16.452c.32 0 .626.059.91.165l-2.133-6.349A1.873 1.873 0 0 0 17.285 4.4H6.719c-.817 0-1.536.508-1.79 1.264L2.776 12.08a2.57 2.57 0 0 1 1.068-.232Z"
        />
    </svg>
)
export const Download = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M20.327 22.003H3.673A1.68 1.68 0 0 1 2 20.33V3.676a1.68 1.68 0 0 1 1.673-1.673h12.49a.74.74 0 0 1 .633.245l4.919 4.919a.844.844 0 0 1 .244.673H22v12.51c0 .898-.755 1.653-1.673 1.653ZM7.837 20.33h8.327v-5.816H7.836v5.816ZM14.51 3.676h-5v5h5v-5Zm5.817 4.552-4.164-4.163v4.612a1.68 1.68 0 0 1-1.673 1.674l-4.98-.001a1.68 1.68 0 0 1-1.673-1.673v-5H3.674V20.35h2.49v-5.836a1.68 1.68 0 0 1 1.673-1.674h8.326a1.68 1.68 0 0 1 1.674 1.674v5.837h2.51V8.228h-.02Z" />
    </svg>
)
export const DynamicCohort = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M13.79 11.505c-.162.553-.3.577-.37.53-.116.601-.416 1.34-1.455 1.386-1.038-.07-1.361-.854-1.454-1.455-.092 0-.185-.115-.3-.53-.162-.578 0-.647.16-.647a1.452 1.452 0 0 1-.045-.878c.07-.323.254-.577.438-.784.116-.14.255-.255.416-.347.115-.092.254-.161.392-.207a.962.962 0 0 1 .37-.07c.392-.023.692.07.9.185.323.185.438.416.438.416s.808.046.462 1.755c.093.068.163.206.048.646Zm3.67 1.27a5.316 5.316 0 0 1-1.131 2.63l1.27 1.27a1.89 1.89 0 0 1 .808-.185c1.062 0 1.916.854 1.916 1.917a1.911 1.911 0 0 1-1.916 1.916 1.911 1.911 0 0 1-1.917-1.916c0-.277.07-.554.185-.808l-1.27-1.27a5.582 5.582 0 0 1-2.746 1.13v1.802a1.904 1.904 0 0 1 1.246 1.8 1.911 1.911 0 0 1-1.916 1.916 1.911 1.911 0 0 1-1.917-1.916c0-.831.532-1.524 1.247-1.8V17.46a5.414 5.414 0 0 1-2.747-1.131l-1.27 1.27c.116.254.185.507.185.808a1.911 1.911 0 0 1-1.916 1.916 1.911 1.911 0 0 1-1.916-1.916c0-1.063.854-1.917 1.916-1.917.277 0 .554.07.808.185l1.27-1.27a5.582 5.582 0 0 1-1.131-2.746h-1.8a1.905 1.905 0 0 1-1.802 1.246A1.911 1.911 0 0 1 1 11.989c0-1.063.854-1.917 1.916-1.917.832 0 1.524.532 1.801 1.247h1.8A5.415 5.415 0 0 1 7.65 8.572l-1.27-1.27a1.888 1.888 0 0 1-.808.185 1.911 1.911 0 0 1-1.916-1.916c0-1.062.854-1.916 1.916-1.916 1.062 0 1.916.854 1.916 1.916 0 .277-.07.554-.185.808l1.27 1.27a5.582 5.582 0 0 1 2.747-1.131v-1.8a1.905 1.905 0 0 1-1.247-1.802c0-1.062.855-1.916 1.917-1.916s1.916.854 1.916 1.916c0 .832-.531 1.524-1.246 1.801v1.8a5.415 5.415 0 0 1 2.746 1.132l1.27-1.27c-.323-.716-.207-1.57.392-2.147a1.923 1.923 0 0 1 2.701 0 1.923 1.923 0 0 1 0 2.7 1.92 1.92 0 0 1-2.147.393l-1.27 1.27a5.634 5.634 0 0 1 1.155 2.862h1.754a1.911 1.911 0 0 1 3.74.555 1.911 1.911 0 0 1-1.916 1.915 1.916 1.916 0 0 1-1.755-1.13h-1.87v-.023Zm-.993-.763a4.458 4.458 0 0 0-4.456-4.455c-2.446 0-4.478 1.985-4.478 4.455 0 1.063.37 2.032.993 2.794.046-.37.185-.762.647-.877a5.84 5.84 0 0 0 1.592-.716l.67 2.077.091.277.3-.831c-.738-1.04.185-.993.185-.993s.947-.046.185.993l.3.831.092-.277.116-.323.553-1.755s.716.508 1.593.716c.462.116.6.532.646.878.602-.762.97-1.731.97-2.794Z" />
    </svg>
)
export const EventAutocapture = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m10.505 9.098 9.499 5.57c.469.293.293.997-.235 1.055l-4.75.762-2.345 4.222c-.234.41-.938.351-.997-.176L9.625 9.684c-.058-.47.469-.82.88-.587Z"
        />
        <path
            opacity=".5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m11.326 3.527-.528 2.932c-.117.586-.938.41-.88-.118l.528-2.99c.117-.587.997-.41.88.176Zm-4.398.587 1.76 2.462c.293.47-.411.997-.763.528l-1.7-2.463c-.351-.469.41-.997.704-.527Zm5.512 3.811 2.404-1.759c.528-.292 0-1.055-.47-.703l-2.462 1.7c-.47.352 0 1.056.528.762Zm-8.15-.234 2.932.527c.586.058.41.938-.118.82l-2.99-.468c-.587-.118-.41-.998.176-.88Zm3.048 2.638-2.462 1.759c-.47.292.058 1.055.527.703l2.463-1.7c.47-.352-.059-1.056-.528-.762Z"
        />
    </svg>
)
export const EventPipelines = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".85"
            d="M22.429 15.997a.227.227 0 0 0 .016-.031l.023-.042c.006-.014.009-.028.013-.042.003-.013.008-.024.01-.037a.43.43 0 0 0 0-.166c-.002-.012-.007-.024-.01-.037-.004-.014-.007-.029-.013-.042a.289.289 0 0 0-.023-.041l-.016-.032a.442.442 0 0 0-.053-.066l-1.117-1.117a.425.425 0 1 0-.602.602l.39.39h-2.69l-5.746-4.256V8.713h5.637c.587 0 1.064-.477 1.064-1.064V3.564c0-.587-.477-1.064-1.064-1.064H6.123c-.587 0-1.064.477-1.064 1.064v4.084c0 .587.477 1.064 1.064 1.064h5.636l.001 2.368-5.746 4.256H4.043a.425.425 0 0 0-.426.425v4.9l-.39-.39a.425.425 0 1 0-.602.602l1.117 1.116a.424.424 0 0 0 .601 0l1.117-1.116a.425.425 0 1 0-.601-.602l-.39.39v-4.474h1.546l5.917 4.384a.426.426 0 0 0 .507 0l5.918-4.384h2.69l-.39.39a.425.425 0 1 0 .601.602l1.117-1.117a.397.397 0 0 0 .053-.065ZM5.91 7.65V3.564c0-.116.097-.213.213-.213h12.125c.116 0 .213.097.213.213v4.084a.215.215 0 0 1-.213.213H6.123a.215.215 0 0 1-.213-.212Zm6.276 12.05L6.87 15.761l5.316-3.938 5.316 3.938-5.316 3.938Z"
        />
        <path opacity=".4" d="M12.186 19.7 6.87 15.76l5.316-3.937 5.316 3.938-5.316 3.938Z" />
    </svg>
)
export const Events = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".7"
            d="M12 6.2c-5.294 0-9 5.824-9 5.824s2.7 5.823 9 5.823c6.353 0 9-5.823 9-5.823S17.347 6.2 12 6.2Zm0 9.529a3.682 3.682 0 0 1-3.705-3.705A3.682 3.682 0 0 1 12 8.318a3.682 3.682 0 0 1 3.705 3.706A3.682 3.682 0 0 1 12 15.729Z"
        />
        <path d="M13.588 12.024a1.588 1.588 0 1 1-3.175 0 1.588 1.588 0 0 1 3.175 0Z" />
    </svg>
)
export const Experiments = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M13.934 10.505v-6.16c.583-.049 1.043-.534 1.043-1.205 0-.63-.509-1.14-1.14-1.14h-3.676c-.623 0-1.132.51-1.132 1.222 0 .589.46 1.075 1.043 1.124v6.16a5.411 5.411 0 0 0-3.502 5.07C6.57 18.567 9.012 21 12.003 21a5.43 5.43 0 0 0 4.47-8.505 5.406 5.406 0 0 0-2.539-1.99ZM9.835 3.14c0-.179.146-.333.323-.333h3.679c.186 0 .331.154.331.414a.326.326 0 0 1-.331.323h-3.679c-.177 0-.323-.146-.323-.404Zm.76 8.037a.408.408 0 0 0 .283-.388V4.352h2.247v6.437c0 .177.113.331.275.388a4.585 4.585 0 0 1 2.903 2.748 7.683 7.683 0 0 0-.76-.032c-1.705 0-2.57.412-3.403.808-.793.38-1.536.745-3.064.745a6.495 6.495 0 0 1-1.665-.194 4.575 4.575 0 0 1 3.184-4.075Z" />
    </svg>
)
export const FeatureFlags = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M6.48 11h11.04c2.2 0 3.979-1.8 3.979-3.98 0-2.2-1.8-3.98-3.98-3.98H6.48c-2.2 0-3.979 1.8-3.979 3.98C2.5 9.2 4.3 11 6.48 11Zm11.04-6.22a2.25 2.25 0 0 1 2.24 2.24c0 1.22-1.02 2.24-2.24 2.24a2.25 2.25 0 0 1-2.24-2.24c0-1.22 1-2.24 2.24-2.24Z" />
        <path
            opacity=".5"
            d="M17.52 13H6.48c-2.2 0-3.98 1.8-3.98 3.98 0 2.2 1.8 3.98 3.98 3.98h11.04c2.2 0 3.98-1.8 3.98-3.98 0-2.18-1.8-3.98-3.98-3.98ZM6.48 19.22a2.25 2.25 0 0 1-2.24-2.24 2.25 2.25 0 0 1 2.24-2.24 2.25 2.25 0 0 1 2.24 2.24c0 1.24-1 2.24-2.24 2.24Z"
        />
    </svg>
)
export const Funnels = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M2.635 19.368a2.182 2.182 0 1 0 4.365 0V5.182a2.182 2.182 0 1 0-4.365 0v14.186Z" />
        <path opacity=".75" d="M9.82 19.368a2.182 2.182 0 1 0 4.364 0v-8.73a2.182 2.182 0 1 0-4.364 0v8.73Z" />
        <path opacity=".5" d="M16.635 19.368a2.182 2.182 0 1 0 4.365 0v-5.456a2.182 2.182 0 1 0-4.365 0v5.456Z" />
    </svg>
)
export const GroupAnalytics = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            d="M4.662 13.963c.054 0 .106.006.157.01v-3.96c-.052.005-.103.011-.157.011-.051 0-.102-.005-.153-.01v3.957c.05-.004.102-.008.153-.008ZM12.155 8.429V5.632c-.051.004-.103.008-.155.008-.053 0-.105-.004-.156-.008v2.797c.052-.003.103-.008.156-.008.052 0 .103.005.155.008Z"
        />
        <path d="M12 8.731a3.266 3.266 0 0 0-3.262 3.262A3.266 3.266 0 0 0 12 15.255a3.266 3.266 0 0 0 3.262-3.262A3.266 3.266 0 0 0 12 8.731Z" />
        <path
            opacity=".5"
            d="M6.403 8.985v.001l2.42 1.379a3.7 3.7 0 0 1 .155-.27L6.526 8.7a2.03 2.03 0 0 1-.123.285Z"
        />
        <path
            opacity=".8"
            d="M12 5.328c.917 0 1.664-.746 1.664-1.664C13.664 2.747 12.917 2 12 2c-.918 0-1.665.747-1.665 1.664 0 .918.747 1.664 1.665 1.664ZM19.334 6.384a1.664 1.664 0 1 0 .005 3.33 1.664 1.664 0 0 0-.005-3.33ZM5.452 6.583a1.664 1.664 0 1 0-1.578 2.93 1.664 1.664 0 0 0 1.578-2.93ZM12 18.658c-.918 0-1.665.747-1.665 1.665 0 .917.747 1.664 1.665 1.664.917 0 1.664-.747 1.664-1.664 0-.919-.747-1.665-1.664-1.665Z"
        />
        <path
            opacity=".5"
            d="M19.49 13.972v-3.957c-.05.004-.102.01-.153.01-.054 0-.105-.007-.157-.011v3.96c.052-.005.104-.011.157-.011.052 0 .102.005.154.01ZM15.175 10.364l2.421-1.379v-.001a2.003 2.003 0 0 1-.124-.286l-2.452 1.396c.056.088.108.178.155.27ZM6.297 6.94l3.827-2.662a1.91 1.91 0 0 1-.076-.326L6.102 6.697c.072.076.137.158.195.243ZM13.876 4.278 17.7 6.94c.058-.086.125-.166.196-.242L13.95 3.952a1.92 1.92 0 0 1-.075.326ZM10.127 19.7l-3.824-2.66a1.934 1.934 0 0 1-.195.243l3.94 2.742c.018-.111.044-.22.079-.325ZM17.697 17.04l-3.824 2.66c.034.105.06.213.076.325l3.942-2.742a1.924 1.924 0 0 1-.194-.242Z"
        />
        <path d="M11.844 15.558v2.797c.051-.004.103-.008.156-.008.052 0 .104.004.155.008v-2.797c-.052.002-.103.008-.155.008-.053 0-.104-.006-.156-.008Z" />
        <path opacity=".8" d="M4.665 17.602a1.668 1.668 0 0 0 1.593-1.186 1.664 1.664 0 1 0-1.593 1.186Z" />
        <path
            opacity=".5"
            d="M8.824 13.623 6.403 15v.002c.05.092.09.188.124.286l2.452-1.396a3.587 3.587 0 0 1-.155-.27Z"
        />
        <path
            opacity=".8"
            d="M18.547 17.403a1.665 1.665 0 0 0 2.254-.677 1.668 1.668 0 0 0-1.464-2.454 1.663 1.663 0 0 0-1.596 2.144c.128.427.415.777.806.987Z"
        />
        <path
            opacity=".5"
            d="M17.596 15.002V15l-2.42-1.378a3.69 3.69 0 0 1-.155.27l2.452 1.395c.034-.096.074-.192.123-.285Z"
        />
    </svg>
)
export const Heatmaps = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path opacity=".7" d="M17.055 12.72a2.965 2.965 0 1 0 0-5.93 2.965 2.965 0 0 0 0 5.93Z" />
        <path d="M10.782 18.88a3.992 3.992 0 1 0 0-7.984 3.992 3.992 0 0 0 0 7.983Z" />
        <path opacity=".5" d="M5.992 11.58a2.167 2.167 0 1 0 0-4.334 2.167 2.167 0 0 0 0 4.334Z" />
        <path opacity=".4" d="M17.853 18.651a1.483 1.483 0 1 0 0-2.965 1.483 1.483 0 0 0 0 2.965Z" />
        <path d="M5.764 3.597a.342.342 0 1 0 0-.685.342.342 0 0 0 0 .685ZM3.483 3.597a.342.342 0 1 0 0-.685.342.342 0 0 0 0 .685ZM4.623 3.597a.342.342 0 1 0 0-.685.342.342 0 0 0 0 .685ZM2.114 4.51h19.879v-.457H2.113v.456Z" />
        <path d="M2.456 2.456V21.16h19.16V2.456H2.456Zm0-.456h19.16a.456.456 0 0 1 .457.456V21.16a.456.456 0 0 1-.457.456H2.456A.456.456 0 0 1 2 21.16V2.456A.456.456 0 0 1 2.456 2Z" />
    </svg>
)
export const JsonPayloads = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M7.795 13.7H8.94a.463.463 0 0 1 .463.463v1.111a.462.462 0 0 1-.463.463H7.794a.462.462 0 0 1-.462-.463v-1.11a.463.463 0 0 1 .463-.463Zm3.645 0h1.155c.252 0 .454.203.454.454v1.13a.452.452 0 0 1-.454.453H11.44a.453.453 0 0 1-.454-.454v-1.129c0-.12.047-.235.134-.32a.445.445 0 0 1 .32-.133Zm3.654 0h1.156c.25 0 .453.203.453.454v1.13a.453.453 0 0 1-.453.453h-1.165a.452.452 0 0 1-.454-.454v-1.129c0-.122.05-.238.136-.324a.457.457 0 0 1 .327-.13ZM3.225 12.163c.318.193.598.444.827.738.213.309.355.66.417 1.031.087.536.127 1.076.116 1.618-.018.362-.018.723 0 1.085.007.184.051.367.133.533a.453.453 0 0 0 .24.24c.16.05.323.087.49.107a.683.683 0 0 1 .462.276c.13.18.198.4.186.622 0 .594-.364.89-1.093.89a2.542 2.542 0 0 1-1.21-.285 2.047 2.047 0 0 1-.826-.8 2.5 2.5 0 0 1-.294-1.192c0-.756 0-1.36-.044-1.778 0-.298-.024-.596-.071-.89a1.662 1.662 0 0 0-.329-.755 2.573 2.573 0 0 0-.57-.471 2.02 2.02 0 0 1-.506-.391.895.895 0 0 1-.151-.56.893.893 0 0 1 .436-.827c.275-.16.533-.351.764-.57a1.27 1.27 0 0 0 .32-.604c.065-.262.1-.531.107-.8 0-.293 0-.987.045-2.098a2.179 2.179 0 0 1 2.329-2.258c.729 0 1.094.302 1.094.889.01.224-.052.446-.178.63a.654.654 0 0 1-.471.268 1.489 1.489 0 0 0-.605.186.594.594 0 0 0-.222.454c-.05.442-.074.889-.071 1.333.002.527-.038 1.054-.116 1.574a2.481 2.481 0 0 1-.391 1.04 2.714 2.714 0 0 1-.818.765Zm16.732-.783a2.482 2.482 0 0 1-.391-1.04 10.342 10.342 0 0 1-.115-1.574c.002-.444-.023-.89-.072-1.333a.594.594 0 0 0-.222-.454 1.488 1.488 0 0 0-.605-.186.654.654 0 0 1-.47-.267 1.026 1.026 0 0 1-.179-.631c0-.587.365-.89 1.094-.89a2.179 2.179 0 0 1 2.33 2.258c0 1.112 0 1.779.044 2.1.007.268.042.537.107.8.048.226.16.435.32.604.23.218.489.409.764.569a.893.893 0 0 1 .436.827.895.895 0 0 1-.151.56 2.018 2.018 0 0 1-.507.391 2.568 2.568 0 0 0-.569.471c-.171.22-.285.48-.329.756a5.663 5.663 0 0 0-.071.889c0 .454 0 1.058-.044 1.778.002.416-.098.825-.294 1.192-.193.34-.48.617-.827.8-.373.193-.789.29-1.209.284-.729 0-1.093-.295-1.093-.889a.977.977 0 0 1 .186-.622.682.682 0 0 1 .463-.276c.166-.02.328-.058.489-.107a.453.453 0 0 0 .24-.24c.082-.166.126-.348.133-.533.018-.362.018-.722 0-1.085a8.97 8.97 0 0 1 .116-1.618c.084-.371.253-.716.489-1.013.229-.294.509-.545.826-.738a2.707 2.707 0 0 1-.889-.783Z" />
    </svg>
)
export const Integrations = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M13.093 2a2.558 2.558 0 0 0-2.558 2.558c0 .618.216 1.186.581 1.628h-5.93v5.93a2.547 2.547 0 0 0-1.628-.581 2.558 2.558 0 1 0 1.628 4.535V22h6.439a2.558 2.558 0 1 1 2.936 0H21v-6.439a2.558 2.558 0 1 1 0-2.936V6.186h-5.93c.365-.442.581-1.01.581-1.628A2.558 2.558 0 0 0 13.093 2Z" />
    </svg>
)
export const Lifecycle = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v7H3V4Z" />
        <path d="M3 11h5v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9Z" fillOpacity=".5" />
        <path d="M9.502 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4h-5V7Z" />
        <path
            d="M9.502 11h5v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-5ZM16 11h5v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3Z"
            fillOpacity=".5"
        />
        <path d="M16 11h5V6a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5Z" />
    </svg>
)
export const LocalEvaluation = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M21.619 18.047h-2.143v-5.714a.714.714 0 0 0-.714-.714h-2.66l-3.054-1.833V6.487a2.14 2.14 0 0 0 1.428-2.011 2.146 2.146 0 0 0-2.143-2.143 2.146 2.146 0 0 0-2.143 2.143c0 .93.6 1.715 1.429 2.011v3.299l-3.055 1.833h-2.66a.714.714 0 0 0-.714.714v5.714H3.048a.714.714 0 0 0-.715.715v2.857c0 .394.32.714.715.714h5.714c.395 0 .714-.32.714-.714v-2.857a.714.714 0 0 0-.714-.715H6.619v-5h1.945l3.402 2.041a.716.716 0 0 0 .735 0l3.402-2.04h1.945v5h-2.143a.714.714 0 0 0-.714.714v2.857c0 .394.32.714.714.714h5.714c.395 0 .714-.32.714-.714v-2.857a.714.714 0 0 0-.714-.715Z" />
    </svg>
)
export const MultivariateTesting = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <g clipPath="url(#Icon/MultivariateTesting__a)">
            <path d="M9.117 24H0v-9.118h9.117V24ZM.43 23.566h8.251v-8.248H.432v8.248ZM9.117 9.118H0V0h9.117v9.118ZM.43 8.682h8.251V.434H.432v8.248Z" />
            <path d="M1.085 19.008h2.387v3.906H1.085v-3.906Zm6.949 3.907H4.122v-3.906h3.912v3.906Zm-3.52-.392H7.64v-3.126H4.515v3.126ZM24 24h-9.118v-9.118H24V24Zm-8.685-.434h8.25v-8.248h-8.25v8.248Z" />
            <path d="M15.968 15.968h6.947v2.386h-6.947v-2.386Zm2.602 6.947h-2.602v-3.906h2.605l-.002 3.906Zm-2.17-.435h1.737l-.002-3.04H16.4v3.04Zm6.515.435h-3.91v-3.906h3.91v3.906Zm-3.518-.392h3.125v-3.126h-3.125v3.126ZM24 9.118h-9.118V0H24v9.118Zm-8.685-.436h8.25V.434h-8.25v8.248Z" />
            <path d="M22.915 3.467h-6.947V.87h6.947v2.597ZM16.4 3.04h6.08V1.3H16.4v1.74ZM8.002 18.354H1.055v-2.602h6.947v2.602Zm-6.511-.431h6.077v-1.739H1.49v1.739ZM15.968 4.125h2.386v3.906h-2.386V4.125Zm3.037 0h3.907v3.906h-3.907V4.125ZM8.03 3.256H1.081V.87H8.03v2.386Zm.001 4.56H5.645V3.91H8.03v3.906Zm-6.946-3.91h3.907v3.906H1.085V3.906Zm12.688 9.438-1.37-1.371 1.37-1.37.282.282L14.4 9.6l-1.285.344.282.283-1.37 1.368-1.372-1.368.28-.283L9.654 9.6l.344 1.285.28-.282 1.371 1.37-1.37 1.37-.28-.282-.345 1.286 1.283-.344-.28-.283 1.37-1.371 1.371 1.37-.282.284 1.285.344-.345-1.286-.282.283Z" />
        </g>
        <defs>
            <clipPath id="Icon/MultivariateTesting__a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
)
export const Notifications = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            d="M18.897 10.92v7.67a.694.694 0 0 1-.692.692H5.744a.694.694 0 0 1-.693-.692V7.513c0-.381.311-.692.693-.692h7.67a4.876 4.876 0 0 1-.055-.693c0-.235.022-.466.055-.692h-7.67a2.08 2.08 0 0 0-2.077 2.077V18.59a2.08 2.08 0 0 0 2.077 2.077h12.461a2.08 2.08 0 0 0 2.077-2.077v-8.088c-.43.205-.895.347-1.385.417Z"
        />
        <path d="M21.667 6.114a3.447 3.447 0 1 1-6.894-.001 3.447 3.447 0 0 1 6.894 0Z" />
    </svg>
)
export const OpenSource = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M12 10.576a1.424 1.424 0 0 0-.294 2.818v7.599c.098.004.196.008.295.008.099 0 .197-.004.294-.007v-7.6a1.425 1.425 0 0 0-.294-2.818Z" />
        <path
            opacity=".7"
            d="M21 12a9 9 0 1 0-9.885 8.956v-.001c-.023-3.658-2.228-6.484-3.143-7.5 0 0-.375-.45-.163-.99l1.667-4.227s.308-.78.993-.78h3.062c.685 0 .993.781.993.781l1.667 4.226c.213.54-.163.99-.163.99v.001c-.915 1.016-3.12 3.841-3.143 7.499v.001C17.44 20.511 21 16.672 21 12Z"
        />
    </svg>
)
export const PathAnalysis = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M17.899 11.632h-1.563a2.456 2.456 0 0 1-1.687-.665l-2.597-2.435-1.897-1.778a3.614 3.614 0 0 0-2.481-.981H6.11c.053.19.08.387.078.584.001.199-.025.397-.078.587h1.563c.624 0 1.226.238 1.68.666l2.697 2.529 1.797 1.684c.673.631 1.56.982 2.482.982h1.563a2.134 2.134 0 0 1-.07-.588c0-.197.026-.394.076-.585Z" />
        <path
            opacity=".5"
            d="m12.973 11.642-.887-.828-.034.069-1.022 1.91.887.831.135-.25.921-1.732ZM9.11 16.393a2.07 2.07 0 0 1-1.832 1.1H6.103c.053.19.08.387.078.584.002.198-.025.397-.078.588h1.175a3.243 3.243 0 0 0 2.866-1.72l.744-1.393-.885-.834-.893 1.675ZM17.9 5.773h-1.176a3.248 3.248 0 0 0-2.866 1.718l-.743 1.394.888.831.89-1.672v.001a2.073 2.073 0 0 1 1.831-1.1h1.179a2.242 2.242 0 0 1-.003-1.172Z"
        />
        <path
            opacity=".5"
            d="M17.9 17.492h-1.564a2.457 2.457 0 0 1-1.68-.665l-2.603-2.422-1.897-1.778a3.61 3.61 0 0 0-2.482-.981H6.111c.05.186.074.378.072.571.002.199-.025.397-.078.588h1.563a2.443 2.443 0 0 1 1.687.662l2.697 2.53 1.797 1.683c.672.631 1.56.982 2.481.981h1.563a2.164 2.164 0 0 1-.078-.588c.002-.196.031-.39.084-.58ZM5.713 6.358A1.858 1.858 0 0 0 2.63 4.964 1.857 1.857 0 0 0 3.626 8.2v2.178a1.856 1.856 0 0 0 0 3.681v2.148a1.857 1.857 0 1 0 .462 0v-2.132a1.856 1.856 0 0 0 0-3.682V8.2a1.857 1.857 0 0 0 1.625-1.841Z"
        />
        <path d="M4.621 4.665A1.857 1.857 0 0 1 4.088 8.2h-.462a1.857 1.857 0 1 1 .995-3.534Z" />
        <path
            opacity=".5"
            d="M22 12.217c-.001-.935-.697-1.724-1.625-1.84V8.198a1.857 1.857 0 1 0-.463 0v2.179a1.856 1.856 0 0 0 0 3.681v2.147a1.857 1.857 0 1 0 .463 0v-2.132A1.856 1.856 0 0 0 22 12.217Z"
        />
        <path d="M20.374 10.377A1.856 1.856 0 0 1 22 12.217a1.856 1.856 0 0 1-1.626 1.856l-.462-.015a1.856 1.856 0 0 1 0-3.681h.462Z" />
    </svg>
)
export const Persons = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".7"
            d="M12.062 13.365s1.24-.02 1.164-3.3c-.078-3.28 1.432-3.818 1.995-4.03 1.642-.617 2.464.373 2.464.373 1.9-.176 2.42 1.901 2.2 4.263-.22 2.364 1.056 2.733 1.056 2.733-.891.911-2.772.854-2.772.854v.84c0 .163.083.316.22.405l.057.035c.66.345 2.015.704 2.042.718.444.12.874.282 1.287.485.493.231.827.704.88 1.245v1.93h-6.15v-2.041a2.444 2.444 0 0 0-.88-1.897c-.27-.22-.542-.44-.813-.633a.487.487 0 0 0 .062-.247v-.82c-2.168.017-2.812-.913-2.812-.913Z"
        />
        <path d="M15.487 17.875a1.436 1.436 0 0 0-.519-1.1 23.458 23.458 0 0 0-3.9-2.557l-1.045 5.698h5.466l-.002-2.041Zm-10.04-6.442c.066.387.2.76.397 1.1v.983l2.168 1.582-.806 1.036.548.88-.435 2.902h1.853l-.426-2.9.548-.88-.818-1.038 2.173-1.58v-.985c.198-.34.333-.713.399-1.1.156-.013.362-.233.585-1.018.292-1.039 0-1.222-.264-1.21.66-3.043-1.045-3.052-1.045-3.052-.143-.636-1.05-1.3-1.892-1.124-.842.176-2.585-.024-2.585-.024a.818.818 0 0 0 .29.633c-1.529.933-1.177 2.985-1.04 3.575-.26 0-.53.2-.244 1.21.224.777.431.997.593 1.01Zm-.025 2.785a23.413 23.413 0 0 0-3.903 2.545 1.437 1.437 0 0 0-.519 1.1v2.053h5.467l-1.045-5.698Z" />
    </svg>
)
export const Playlist = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="m20.304 13.35-4.59-2.628a1.446 1.446 0 0 0-1.476 0c-.468.27-.738.755-.738 1.278v5.238c0 .54.27 1.009.738 1.279.234.144.486.198.739.198.251 0 .504-.072.738-.198l4.59-2.629a1.49 1.49 0 0 0 .756-1.296c-.001-.486-.29-.972-.757-1.242Z" />
        <rect x="3" y="5" width="18" height="3" rx="1.5" />
        <rect x="3" y="10.5" width="8" height="3" rx="1.5" />
        <rect x="3" y="16" width="8" height="3" rx="1.5" />
    </svg>
)
export const PosthogMonochrome = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            d="M6.105 12a.788.788 0 0 1-1.412-.7v-.001a.788.788 0 0 1 1.412.7ZM6.105 16.432a.788.788 0 1 1-1.412-.7.788.788 0 1 1 1.412.7Z"
            fillOpacity=".25"
        />
        <path
            d="M1 15.38a.44.44 0 0 1 .751-.314l2.017 2.032c.277.28.08.757-.311.757H1.44a.442.442 0 0 1-.44-.443V15.38Zm0-2.141c0 .117.046.23.129.313l4.14 4.173c.083.083.195.13.312.13h2.274a.444.444 0 0 0 .311-.757l-6.415-6.465a.44.44 0 0 0-.751.314v2.292Zm0-4.433c0 .118.046.23.129.314l8.54 8.605c.082.083.194.13.31.13h2.275a.444.444 0 0 0 .311-.757L1.751 6.2A.44.44 0 0 0 1 6.514v2.292Zm4.399 0c0 .118.046.23.129.314l7.917 7.978a.44.44 0 0 0 .751-.313v-2.292a.445.445 0 0 0-.129-.314L6.15 6.2a.44.44 0 0 0-.751.314v2.292Zm5.15-2.606a.44.44 0 0 0-.752.314v2.292c0 .118.047.23.13.314l3.518 3.546a.44.44 0 0 0 .751-.314V10.06a.445.445 0 0 0-.129-.314L10.55 6.2Z"
            fill="#606060"
        />
        <path d="m19.71 15.434-4.14-4.174a.44.44 0 0 0-.752.314v5.838c0 .245.197.443.44.443h6.416c.243 0 .44-.198.44-.443v-.532c0-.245-.198-.44-.44-.472a3.388 3.388 0 0 1-1.963-.974Zm-2.78 1.003a.707.707 0 0 1-.704-.71c0-.391.315-.709.704-.709.388 0 .703.318.703.71 0 .391-.315.709-.703.709Z" />
        <path
            d="M1 17.412c0 .245.197.443.44.443h2.017a.444.444 0 0 0 .31-.757l-2.016-2.032a.44.44 0 0 0-.751.313v2.033ZM5.399 9.876 1.75 6.2A.44.44 0 0 0 1 6.514v2.292c0 .118.046.23.129.314l4.27 4.302V9.876ZM1.751 10.633a.44.44 0 0 0-.751.314v2.292c0 .117.046.23.129.313l4.27 4.303V14.31L1.75 10.633Z"
            fill="#BFBFBC"
        />
        <path
            d="M9.797 10.06a.445.445 0 0 0-.129-.314L6.15 6.2a.44.44 0 0 0-.751.314v2.292c0 .118.046.23.129.314l4.27 4.302V10.06ZM5.399 17.855h2.456a.444.444 0 0 0 .311-.757L5.4 14.31v3.546ZM5.399 9.876v3.363c0 .117.046.23.129.313l4.27 4.303v-3.362a.445.445 0 0 0-.13-.314l-4.27-4.303Z"
            fill="gray"
        />
    </svg>
)
export const Projects = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".8"
            d="M3 11.532v5.858c0 1.094.881 1.976 1.976 1.976h14.048A1.972 1.972 0 0 0 21 17.39v-5.858c-2.102 1.047-4.783 1.723-7.745 1.873-.171.529-.67.912-1.255.912a1.313 1.313 0 0 1-1.248-.912c-2.965-.15-5.649-.826-7.752-1.873Z"
        />
        <path d="M4.976 6.634A1.972 1.972 0 0 0 3 8.61v1.934c2.01 1.09 4.73 1.825 7.772 1.983a1.321 1.321 0 0 1 2.463 0c3.04-.159 5.757-.895 7.765-1.983V8.61a1.972 1.972 0 0 0-1.976-1.976H4.976Z" />
        <path opacity=".6" d="M9.146 4a.438.438 0 0 0-.439.439v1.317h6.586V4.44a.438.438 0 0 0-.44-.439H9.147Z" />
    </svg>
)
export const Retention = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m21 12.783-2.696-2.696-2.435 2.942 2.696 2.696L21 12.783ZM10.97 8.145l2.957-2.449L11.232 3 8.275 5.435l2.696 2.71Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m14.9 14.203-1.478 1.782c-1.348 1.609-3.913 1.478-5.392 0-1.493-1.492-1.623-4.057 0-5.405l1.754-1.45-2.681-2.71L5.32 7.886c-3.217 2.68-2.956 7.825 0 10.797 2.971 2.97 8.117 3.231 10.797 0l1.464-1.769-2.681-2.71Z"
        />
    </svg>
)
export const Sampling = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            d="M9.544 10.101a5.306 5.306 0 0 1 4.68 7.673 5.313 5.313 0 0 1-7.12 2.39 5.305 5.305 0 0 1-2.383-7.116A5.314 5.314 0 0 1 9.544 10.1Zm.016-1.16a6.47 6.47 0 0 0-5.88 3.59 6.466 6.466 0 0 0 11 6.71l4.718 2.349c.55.273 1.212.05 1.485-.499a1.105 1.105 0 0 0-.498-1.485L15.67 17.26A6.468 6.468 0 0 0 9.56 8.94ZM5.827 5.44c-.338 0-.61.218-.61.676v1.24c0 .123.006.158.094.266l.14.175c.04.05.062.092.074.172l.178 1.104a.657.657 0 0 0 .098.278 7.23 7.23 0 0 1 1.346-.634l.12-.75a.322.322 0 0 1 .073-.171l.142-.175c.086-.108.092-.142.092-.267V6.115c0-.46-.272-.676-.61-.676H5.826ZM9.918 5.44c-.337 0-.61.218-.61.676v1.24c0 .123.007.158.094.266l.141.175c.04.05.06.092.073.172l.057.357c.53.015 1.064.09 1.59.227l.095-.585a.31.31 0 0 1 .073-.172l.142-.175c.087-.108.094-.142.094-.267V6.115c0-.46-.273-.676-.611-.676H9.918Z"
            clipRule="evenodd"
        />
        <path
            fillRule="evenodd"
            d="M18.1 13.07c-.338 0-.611.218-.611.676v1.24c0 .123.005.158.093.266l.141.175a.31.31 0 0 1 .074.172l.177 1.105c.047.295.168.45.527.45h.334c.359 0 .479-.155.527-.45l.177-1.105a.327.327 0 0 1 .073-.172l.142-.175c.087-.108.092-.143.092-.266v-1.24c0-.459-.272-.676-.609-.676H18.1ZM14.009 5.44c-.34 0-.61.218-.61.676v1.24c0 .123.006.158.092.266l.142.175c.04.05.06.092.073.172l.177 1.104c.047.295.168.452.526.452h.336c.358 0 .478-.157.525-.452l.178-1.104a.317.317 0 0 1 .073-.172l.141-.175c.088-.108.095-.142.095-.267v-1.24c0-.458-.273-.675-.611-.675h-1.137ZM18.1 5.44c-.338 0-.611.218-.611.676v1.24c0 .123.005.158.093.266l.141.175a.31.31 0 0 1 .074.172l.177 1.104c.047.295.168.452.527.452h.334c.359 0 .479-.157.527-.452l.177-1.104a.324.324 0 0 1 .073-.172l.142-.175c.087-.108.092-.142.092-.267v-1.24c0-.458-.272-.675-.609-.675H18.1ZM7.18 3.65c.103.456-.163.912-.598 1.02-.433.109-.868-.173-.972-.628-.104-.454.164-.91.598-1.019.432-.108.868.172.972.627ZM11.271 3.65c.103.456-.164.912-.598 1.02-.434.109-.87-.173-.973-.628-.102-.454.165-.91.598-1.019.434-.108.87.172.973.627ZM15.362 3.65c.104.456-.164.912-.598 1.02-.433.109-.868-.173-.972-.628-.104-.454.162-.91.597-1.019.434-.108.87.172.973.627ZM19.453 3.65c.103.456-.164.912-.596 1.02-.434.109-.87-.173-.974-.628-.104-.454.165-.91.597-1.019.434-.108.87.172.973.627ZM19.453 11.28c.103.456-.164.912-.596 1.02-.434.108-.87-.172-.974-.627-.104-.454.165-.91.597-1.02.434-.108.87.173.973.628ZM6.452 13.706h1.851c.164 0 .293.045.385.13.092.086.157.222.157.442v2.088c0 .218-.03.287-.167.445-.054.06-.113.128-.16.186-.028.035-.025.083-.032.127l-.308 2.117c-.044.303-.616.314-.626.03l-.068-2.038c-.007-.201-.231-.196-.238 0l-.087 2.038c-.013.284-.542.273-.585-.03l-.313-2.173a.188.188 0 0 0-.068-.12l-.12-.138c-.147-.169-.165-.245-.165-.452v-2.08c0-.22.065-.356.156-.442a.554.554 0 0 1 .388-.13ZM8.183 12.187a.848.848 0 0 1-.614 1.022.83.83 0 0 1-1-.629.848.848 0 0 1 .613-1.02.83.83 0 0 1 1 .627ZM10.635 13.706h1.852a.55.55 0 0 1 .385.13c.092.086.157.222.157.442v2.088c0 .218-.03.287-.167.445-.054.06-.113.128-.16.186-.028.035-.025.083-.031.127l-.308 2.117c-.043.303-.616.314-.625.03l-.07-2.038c-.006-.201-.23-.196-.237 0l-.086 2.038c-.013.284-.542.273-.587-.03l-.313-2.173a.18.18 0 0 0-.067-.12l-.12-.138c-.147-.169-.166-.245-.166-.452v-2.08c0-.22.066-.356.157-.442a.554.554 0 0 1 .386-.13ZM12.367 12.187a.848.848 0 0 1-.614 1.022.829.829 0 0 1-1-.629.847.847 0 0 1 .614-1.02.828.828 0 0 1 1 .627Z"
            clipRule="evenodd"
        />
    </svg>
)
export const SelfHosting = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 7.812A2.813 2.813 0 0 0 18.187 5H5.813A2.813 2.813 0 0 0 3 7.812v1.125a2.813 2.813 0 0 0 2.813 2.813h5.625v2.306a2.817 2.817 0 0 0-2.126 1.927.554.554 0 0 0-.125-.014H3.563a.562.562 0 1 0 0 1.125H9.2a2.812 2.812 0 0 0 5.597 0h5.64a.562.562 0 1 0 0-1.125h-5.625a.555.555 0 0 0-.125.014 2.817 2.817 0 0 0-2.126-1.927V11.75h5.625A2.813 2.813 0 0 0 21 8.937V7.812Zm-15.75.563a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.5-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
        />
    </svg>
)
export const SessionRecording = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            d="M2 8.843V2.456C2 2.204 2.204 2 2.456 2h6.387a.456.456 0 0 1 0 .912H2.912v5.93A.456.456 0 0 1 2 8.843ZM21.617 2h-6.388a.456.456 0 0 0 0 .912h5.931v5.93a.456.456 0 0 0 .912 0V2.456A.456.456 0 0 0 21.618 2Zm0 12.774a.456.456 0 0 0-.456.456v5.93h-5.932a.456.456 0 0 0 0 .913h6.388a.456.456 0 0 0 .456-.456v-6.388a.456.456 0 0 0-.456-.455ZM8.843 21.16H2.912V15.23a.456.456 0 0 0-.912 0v6.387c0 .251.204.456.456.456h6.387a.456.456 0 0 0 0-.912Z"
        />
        <path d="M16.142 12.036a4.111 4.111 0 0 0-4.106-4.106 4.111 4.111 0 0 0-4.106 4.106 4.111 4.111 0 0 0 4.106 4.106 4.111 4.111 0 0 0 4.106-4.106Z" />
    </svg>
)
export const Sessions = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".6"
            d="M11.557 2.557a9.002 9.002 0 0 0-9 9 9.002 9.002 0 0 0 9 9 9.002 9.002 0 0 0 9-9 9.002 9.002 0 0 0-9-9Zm0 16.364a7.362 7.362 0 0 1-7.364-7.364 7.362 7.362 0 0 1 7.364-7.364 7.361 7.361 0 0 1 7.364 7.364 7.362 7.362 0 0 1-7.364 7.364Z"
        />
        <path d="M12.376 11.222V6.648a.819.819 0 0 0-1.637 0v4.91c0 .217.084.426.238.58l2.454 2.455a.818.818 0 0 0 1.154-1.154l-2.21-2.217Z" />
    </svg>
)
export const Settings = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M20.07 10h-1.685a.628.628 0 0 1-.598-.4.62.62 0 0 1 .14-.705l1.192-1.191a.925.925 0 0 0 0-1.307l-1.52-1.52a.948.948 0 0 0-1.31 0L15.097 6.07h.001a.646.646 0 0 1-1.1-.457V3.93a.93.93 0 0 0-.927-.93h-2.15a.928.928 0 0 0-.93.928v1.684a.645.645 0 0 1-1.1.457L7.7 4.878a.948.948 0 0 0-1.31 0l-1.52 1.52a.925.925 0 0 0 0 1.306l1.19 1.194A.647.647 0 0 1 5.603 10H3.93a.927.927 0 0 0-.929.92v2.16a.926.926 0 0 0 .93.928h1.682a.627.627 0 0 1 .597.402c.1.239.041.516-.149.692L4.87 16.295a.926.926 0 0 0 0 1.307l1.519 1.52v-.001a.946.946 0 0 0 1.31 0l1.192-1.192a.645.645 0 0 1 1.1.458v1.683a.931.931 0 0 0 .93.93h2.16a.929.929 0 0 0 .93-.928v-1.685a.63.63 0 0 1 .397-.598.62.62 0 0 1 .704.14l1.192 1.193-.001-.001a.946.946 0 0 0 1.31 0l1.52-1.52v.001a.926.926 0 0 0 0-1.307l-1.192-1.192A.647.647 0 0 1 18.397 14h1.684a.929.929 0 0 0 .92-.92v-2.16a.932.932 0 0 0-.932-.92ZM12 14.34a2.341 2.341 0 1 1 0-4.682 2.341 2.341 0 0 1 0 4.682Z" />
    </svg>
)
export const SQL = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M16.64 5.28a.293.293 0 0 0-.171 0h-.258c-1.598 0-3.06.55-4.211 1.478A6.675 6.675 0 0 0 7.789 5.28C4.076 5.262 1.05 8.287 1.05 12c0 3.713 3.025 6.738 6.738 6.738 1.598 0 3.06-.55 4.211-1.479a6.675 6.675 0 0 0 4.211 1.479c3.713 0 6.738-3.025 6.738-6.738 0-3.575-2.802-6.497-6.308-6.72ZM7.79 17.878A5.887 5.887 0 0 1 1.91 12a5.876 5.876 0 0 1 5.878-5.878c1.34 0 2.578.447 3.558 1.203A6.72 6.72 0 0 0 9.457 12a6.75 6.75 0 0 0 1.89 4.675 5.805 5.805 0 0 1-3.558 1.203Zm4.726-2.372a5.615 5.615 0 0 1-.516.602 5.807 5.807 0 0 1-1.564-2.974c.052-.017.086-.051.137-.085a.415.415 0 0 0 0-.602l-.068-.069a.356.356 0 0 0-.172-.103V12c0-.619.103-1.22.275-1.787a.443.443 0 0 0 .12.378l.069.068c.086.086.189.12.31.12.12 0 .223-.034.309-.12a.415.415 0 0 0 0-.601l-.07-.069a.415.415 0 0 0-.6 0c-.035.034-.07.069-.087.12a5.91 5.91 0 0 1 1.118-1.942.421.421 0 0 0 .275.103.345.345 0 0 0 .223-.068l.206.257a.447.447 0 0 0 .069.499l.12.12c.086.086.19.12.293.12A5.89 5.89 0 0 1 13.667 12c0 .31-.017.601-.069.894-.12.12-.137.292-.086.447a5.555 5.555 0 0 1-.67 1.65.36.36 0 0 0-.223.12.42.42 0 0 0-.103.395Zm9.23-3.987.068.069c.069.068.172.12.275.12v.31c0 .618-.103 1.22-.275 1.787a.443.443 0 0 0-.12-.378l-.069-.07a.415.415 0 0 0-.602 0c-.154.173-.171.448 0 .603l.07.068c.085.086.188.12.309.12.12 0 .223-.034.309-.12.034-.034.069-.069.086-.12a5.913 5.913 0 0 1-1.117 1.942c-.172-.137-.43-.137-.585.017a.426.426 0 0 0-.017.585 5.909 5.909 0 0 1-1.942 1.117.524.524 0 0 0 .12-.086.415.415 0 0 0 0-.602l-.086-.068a.415.415 0 0 0-.601 0c-.155.171-.172.446 0 .601l.069.069c.085.086.189.12.309.12h.069a5.634 5.634 0 0 1-1.788.275h-.206c-.155-.137-.361-.154-.516-.034-.137-.017-.275-.035-.395-.069a.307.307 0 0 0 .12-.086.415.415 0 0 0 0-.601l-.137-.12a.415.415 0 0 0-.602 0c-.155.171-.172.446 0 .6l.069.07a5.67 5.67 0 0 1-1.925-.98c.24-.258.464-.533.67-.808.017-.017.035-.017.035-.034a.409.409 0 0 0 .103-.19 6.906 6.906 0 0 0 .876-2.027s.018 0 .018-.018a.425.425 0 0 0 .085-.48 6.05 6.05 0 0 0 .104-1.135c0-.396-.035-.79-.104-1.17l.138.138c.086.086.189.12.31.12a.441.441 0 0 0 .309-.12.415.415 0 0 0 0-.601l-.12-.12a.415.415 0 0 0-.602 0 .404.404 0 0 0-.103.154 11.289 11.289 0 0 0-.104-.378.448.448 0 0 0 0-.601l-.12-.12a.41.41 0 0 0-.189-.104 7.268 7.268 0 0 0-1.272-1.856 5.994 5.994 0 0 1 1.668-.894.52.52 0 0 0-.12.086.415.415 0 0 0 0 .602l.068.068c.086.086.189.12.31.12.12 0 .223-.034.309-.12a.415.415 0 0 0 0-.601l-.07-.069a.443.443 0 0 0-.377-.12 5.635 5.635 0 0 1 1.787-.275h.172a.458.458 0 0 0 .206.051c.052 0 .12-.017.172-.034l.413.051a.415.415 0 0 0-.069.653l.12.12c.086.087.19.121.31.121s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.086-.017a5.89 5.89 0 0 1 4.177 4.452.41.41 0 0 0-.224.12.436.436 0 0 0 0 .619Z" />
        <path d="m17.981 13.169-.12-.12a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .6l.12.121c.087.086.19.12.31.12a.441.441 0 0 0 .31-.12c.154-.172.154-.447-.018-.601ZM19.734 14.922a.415.415 0 0 0-.601 0c-.155.172-.172.447 0 .601l.12.12c.086.087.19.121.31.121s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.138-.12ZM18.91 14.097l-.121-.12a.415.415 0 0 0-.602 0c-.154.171-.171.446 0 .601l.12.12c.087.086.19.12.31.12s.223-.034.31-.12c.154-.154.154-.43-.018-.601ZM15.489 11.897c.086.086.19.12.31.12a.44.44 0 0 0 .309-.12.415.415 0 0 0 0-.602l-.12-.12a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .601l.103.12ZM16.916 12.103a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .602l.12.12c.086.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.601l-.138-.12ZM12.756 12.619c.086.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.602l-.121-.12a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .601l.103.12ZM16.194 14.853a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .602l.12.12c.086.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.601l-.138-.12ZM15.214 13.856a.415.415 0 0 0-.602 0c-.154.172-.171.447 0 .602l.12.12c.087.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.601l-.138-.12ZM17.174 15.833a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .601l.12.12c.086.087.19.121.31.121s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.137-.12ZM11.777 11.639c.085.086.189.12.309.12a.441.441 0 0 0 .31-.12.415.415 0 0 0 0-.602l-.121-.12a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .602l.104.12ZM19.666 11.381a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .602l.12.12c.086.086.19.12.31.12a.441.441 0 0 0 .31-.12.415.415 0 0 0 0-.601l-.138-.12ZM15.85 8.167a.415.415 0 0 0 0-.601l-.12-.12a.415.415 0 0 0-.602 0c-.155.171-.172.446 0 .6l.12.121c.086.086.19.12.31.12s.206-.034.292-.12ZM16.228 9.147c.086.086.19.12.31.12s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.12-.12a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .602l.103.12ZM20.645 12.361a.415.415 0 0 0-.601 0c-.155.172-.172.447 0 .602l.12.12c.086.086.19.12.31.12s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.138-.12ZM18.669 10.402a.415.415 0 0 0-.602 0c-.155.171-.172.446 0 .601l.12.12c.086.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.601l-.138-.12ZM17.208 10.144c.086.086.189.12.31.12a.441.441 0 0 0 .309-.12.415.415 0 0 0 0-.602l-.12-.12a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .601l.103.12ZM12.31 14.183a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .601l.12.12c.086.087.19.121.31.121a.44.44 0 0 0 .309-.12.415.415 0 0 0 0-.602l-.138-.12ZM14.166 16.039a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .602l.12.12c.086.086.19.12.31.12s.223-.034.31-.12a.415.415 0 0 0 0-.602l-.138-.12ZM11.502 13.358l-.12-.12a.415.415 0 0 0-.602 0 .415.415 0 0 0 0 .601l.12.12c.086.086.189.12.31.12a.441.441 0 0 0 .309-.12c.137-.154.137-.43-.018-.601ZM18.153 7.91c.086.085.19.12.31.12s.223-.035.309-.12a.415.415 0 0 0 0-.602l-.12-.12a.415.415 0 0 0-.602 0c-.155.171-.172.446 0 .601l.103.12ZM21.419 9.972a.415.415 0 0 0-.602 0c-.155.172-.172.447 0 .601l.12.12c.086.087.19.121.31.121s.223-.034.31-.12a.415.415 0 0 0 0-.602l-.138-.12ZM19.889 9.645l.12.12c.086.087.19.121.31.121s.223-.034.309-.12a.415.415 0 0 0 0-.602l-.12-.12a.415.415 0 0 0-.602 0c-.155.172-.189.447-.017.601ZM18.961 8.717l.12.12c.086.086.19.12.31.12a.441.441 0 0 0 .31-.12.415.415 0 0 0 0-.601l-.121-.12a.415.415 0 0 0-.602 0c-.189.171-.189.446-.017.601Z" />
    </svg>
)
export const SSO = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.605 11.24c-.103-2.886-2.886-4.844-5.617-4.07-2.576-3.864-8.604-2.267-8.81 2.421-4.843 1.34-3.915 8.657 1.186 8.657H18.42c4.07 0 4.946-5.771 1.186-7.007l-.001-.001Zm-2.607.197a2.75 2.75 0 1 1-4.366 3.25l-6.418.003a.25.25 0 0 1-.177-.073l-1.061-1.06a.25.25 0 0 1 0-.354l1.06-1.06a.25.25 0 0 1 .178-.074h.353a.25.25 0 0 1 .177.073l.53.53.53-.53a.25.25 0 0 1 .177-.073h.354a.25.25 0 0 1 .176.073l.707.708.707-.707a.25.25 0 0 1 .177-.074h.354a.25.25 0 0 1 .177.073l.707.708.707-.707a.25.25 0 0 1 .176-.074H12.636a2.753 2.753 0 0 1 4.362-.632Zm-.886 1.59a.5.5 0 1 0-.707.706.5.5 0 0 0 .708-.707Z"
        />
    </svg>
)
export const Stickiness = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".5"
            d="M2.723 12.754h.249a9.136 9.136 0 0 0 6.2 7.827.235.235 0 0 0 .244-.384l-.193-.203a1.178 1.178 0 0 1-.003-1.61l.885-.935v.001a.236.236 0 0 0-.085-.38 5.517 5.517 0 0 1-3.433-4.316h.315a.704.704 0 0 0 .484-1.214l-2.09-1.976a.698.698 0 0 0-.966 0L2.238 11.54a.703.703 0 0 0 .485 1.214Z"
        />
        <path
            opacity=".6"
            d="M12.311 16.445a.698.698 0 0 0-.77.17l-1.978 2.09a.706.706 0 0 0 0 .967l1.978 2.088a.702.702 0 0 0 1.214-.483v-.274a9.133 9.133 0 0 0 7.853-6.201.234.234 0 0 0-.384-.244l-.232.219a1.171 1.171 0 0 1-1.61-.001l-.922-.871a.236.236 0 0 0-.379.083 5.52 5.52 0 0 1-4.326 3.4v-.29a.699.699 0 0 0-.444-.653Z"
        />
        <path
            opacity=".8"
            d="M14.777 4.005a1.18 1.18 0 0 1 .004 1.61l-.848.896a.236.236 0 0 0 .084.379 5.52 5.52 0 0 1 3.403 4.356h-.321a.704.704 0 0 0-.485 1.214l2.09 1.977c.271.256.696.256.966 0l2.092-1.977a.702.702 0 0 0-.485-1.214h-.242a9.117 9.117 0 0 0-6.281-7.906.236.236 0 0 0-.268.1.237.237 0 0 0 .026.284l.265.281Z"
        />
        <path d="M3.466 9.493c.09.057.207.045.286-.028l.257-.243a1.17 1.17 0 0 1 1.613.005l.902.853a.237.237 0 0 0 .38-.085 5.503 5.503 0 0 1 4.341-3.438v.345a.703.703 0 0 0 1.214.483l1.979-2.09a.706.706 0 0 0 0-.965l-1.979-2.09a.703.703 0 0 0-1.214.483v.218a9.121 9.121 0 0 0-7.878 6.283.233.233 0 0 0 .099.27v-.001Z" />
    </svg>
)
export const Surveys = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            d="M9.544 10.101a5.306 5.306 0 0 1 4.68 7.673 5.313 5.313 0 0 1-7.12 2.39 5.305 5.305 0 0 1-2.383-7.116A5.314 5.314 0 0 1 9.544 10.1Zm.016-1.16a6.47 6.47 0 0 0-5.88 3.59 6.466 6.466 0 0 0 11 6.71l4.718 2.349c.55.273 1.212.05 1.485-.499a1.105 1.105 0 0 0-.498-1.485L15.67 17.26A6.468 6.468 0 0 0 9.56 8.94ZM5.827 5.44c-.338 0-.61.218-.61.676v1.24c0 .123.006.158.094.266l.14.175c.04.05.062.092.074.172l.178 1.104a.657.657 0 0 0 .098.278 7.23 7.23 0 0 1 1.346-.634l.12-.75a.322.322 0 0 1 .073-.171l.142-.175c.086-.108.092-.142.092-.267V6.115c0-.46-.272-.676-.61-.676H5.826ZM9.918 5.44c-.337 0-.61.218-.61.676v1.24c0 .123.007.158.094.266l.141.175c.04.05.06.092.073.172l.057.357c.53.015 1.064.09 1.59.227l.095-.585a.31.31 0 0 1 .073-.172l.142-.175c.087-.108.094-.142.094-.267V6.115c0-.46-.273-.676-.611-.676H9.918Z"
            clipRule="evenodd"
        />
        <path
            fillRule="evenodd"
            d="M18.1 13.07c-.338 0-.611.218-.611.676v1.24c0 .123.005.158.093.266l.141.175a.31.31 0 0 1 .074.172l.177 1.105c.047.295.168.45.527.45h.334c.359 0 .479-.155.527-.45l.177-1.105a.327.327 0 0 1 .073-.172l.142-.175c.087-.108.092-.143.092-.266v-1.24c0-.459-.272-.676-.609-.676H18.1ZM14.009 5.44c-.34 0-.61.218-.61.676v1.24c0 .123.006.158.092.266l.142.175c.04.05.06.092.073.172l.177 1.104c.047.295.168.452.526.452h.336c.358 0 .478-.157.525-.452l.178-1.104a.317.317 0 0 1 .073-.172l.141-.175c.088-.108.095-.142.095-.267v-1.24c0-.458-.273-.675-.611-.675h-1.137ZM18.1 5.44c-.338 0-.611.218-.611.676v1.24c0 .123.005.158.093.266l.141.175a.31.31 0 0 1 .074.172l.177 1.104c.047.295.168.452.527.452h.334c.359 0 .479-.157.527-.452l.177-1.104a.324.324 0 0 1 .073-.172l.142-.175c.087-.108.092-.142.092-.267v-1.24c0-.458-.272-.675-.609-.675H18.1ZM7.18 3.65c.103.456-.163.912-.598 1.02-.433.109-.868-.173-.972-.628-.104-.454.164-.91.598-1.019.432-.108.868.172.972.627ZM11.271 3.65c.103.456-.164.912-.598 1.02-.434.109-.87-.173-.973-.628-.102-.454.165-.91.598-1.019.434-.108.87.172.973.627ZM15.362 3.65c.104.456-.164.912-.598 1.02-.433.109-.868-.173-.972-.628-.104-.454.162-.91.597-1.019.434-.108.87.172.973.627ZM19.453 3.65c.103.456-.164.912-.596 1.02-.434.109-.87-.173-.974-.628-.104-.454.165-.91.597-1.019.434-.108.87.172.973.627ZM19.453 11.28c.103.456-.164.912-.596 1.02-.434.108-.87-.172-.974-.627-.104-.454.165-.91.597-1.02.434-.108.87.173.973.628ZM6.452 13.706h1.851c.164 0 .293.045.385.13.092.086.157.222.157.442v2.088c0 .218-.03.287-.167.445-.054.06-.113.128-.16.186-.028.035-.025.083-.032.127l-.308 2.117c-.044.303-.616.314-.626.03l-.068-2.038c-.007-.201-.231-.196-.238 0l-.087 2.038c-.013.284-.542.273-.585-.03l-.313-2.173a.188.188 0 0 0-.068-.12l-.12-.138c-.147-.169-.165-.245-.165-.452v-2.08c0-.22.065-.356.156-.442a.554.554 0 0 1 .388-.13ZM8.183 12.187a.848.848 0 0 1-.614 1.022.83.83 0 0 1-1-.629.848.848 0 0 1 .613-1.02.83.83 0 0 1 1 .627ZM10.635 13.706h1.852a.55.55 0 0 1 .385.13c.092.086.157.222.157.442v2.088c0 .218-.03.287-.167.445-.054.06-.113.128-.16.186-.028.035-.025.083-.031.127l-.308 2.117c-.043.303-.616.314-.625.03l-.07-2.038c-.006-.201-.23-.196-.237 0l-.086 2.038c-.013.284-.542.273-.587-.03l-.313-2.173a.18.18 0 0 0-.067-.12l-.12-.138c-.147-.169-.166-.245-.166-.452v-2.08c0-.22.066-.356.157-.442a.554.554 0 0 1 .386-.13ZM12.367 12.187a.848.848 0 0 1-.614 1.022.829.829 0 0 1-1-.629.847.847 0 0 1 .614-1.02.828.828 0 0 1 1 .627Z"
            clipRule="evenodd"
        />
    </svg>
)
export const TeamCollaboration = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="m11.354 11.956 5.92 5.921a8.345 8.345 0 0 1-5.92 2.454c-1.55 0-3.014-.43-4.263-1.162-1.25.947-2.606 1.098-3.53.969-.324-.043-.388-.474-.087-.604.84-.408 1.378-1.248 1.701-1.915A8.33 8.33 0 0 1 3 11.978a8.37 8.37 0 0 1 8.375-8.375v8.353h-.021Z" />
        <path
            opacity=".7"
            d="m14.39 13.076 6.567-2.669c-.043-.301-.086-.624-.15-.926L13.7 12.366l.69.71Zm-1.722-1.744.345.345 7.557-3.08c-.107-.28-.215-.56-.345-.839l-7.535 3.08-.022.494Zm0-2.454v.99l7.105-2.884c-.173-.258-.345-.516-.538-.753l-6.567 2.647Zm0-.969 5.943-2.411a7.339 7.339 0 0 0-.754-.668L12.69 6.94l-.022.97Zm.02-1.981 4.285-1.745a6.277 6.277 0 0 0-1.077-.538L12.69 4.96v.969Zm0-1.96 1.874-.753A8.894 8.894 0 0 0 12.689 3v.969Zm5.836 13.307c.453-.43.84-.926 1.162-1.464l-1.873.753.711.71Zm-1.378-1.4 3.207-1.313c.15-.366.28-.754.388-1.142l-4.284 1.745.689.71Zm-2.067-2.089.689.69 5.167-2.111c.043-.323.065-.668.065-.99v-.023l-5.92 2.434Z"
        />
    </svg>
)
export const Toolbar = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            opacity=".7"
            d="M19.576 4H4.423A2.415 2.415 0 0 0 2 6.423v10.924a2.415 2.415 0 0 0 2.423 2.423h15.154A2.415 2.415 0 0 0 22 17.347V6.424A2.43 2.43 0 0 0 19.575 4Zm1.542 13.348c0 .859-.683 1.542-1.542 1.542H4.423a1.533 1.533 0 0 1-1.542-1.542V8.274H21.12v9.074Zm0-9.955H2.881v-.97c0-.858.683-1.54 1.542-1.54h15.154c.859 0 1.542.682 1.542 1.54v.97Z"
        />
        <path opacity=".8" d="M4.974 6.159c0 .999-1.498.999-1.498 0 0-1 1.498-1 1.498 0Z" />
        <path opacity=".6" d="M7.242 6.159c0 .999-1.497.999-1.497 0 0-1 1.497-1 1.497 0Z" />
        <path opacity=".4" d="M9.534 6.159c0 .999-1.498.999-1.498 0 0-1 1.498-1 1.498 0Z" />
        <path d="m13.07 14.17 2.238.045-4.975-4.548v6.75l1.51-1.67 1.11 2.515c.152.346.552.497.898.346.347-.15.498-.55.347-.897l-1.129-2.54Z" />
    </svg>
)
export const Trends = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.911 4.808a1.5 1.5 0 0 1 .28 2.103l-5.395 7.056a2.5 2.5 0 0 1-2.883.814L9.67 13.15l-5.61 5.61a1.5 1.5 0 1 1-2.122-2.12l5.84-5.841a2.5 2.5 0 0 1 2.666-.566l4.195 1.614 5.168-6.758a1.5 1.5 0 0 1 2.103-.28Z"
        />
    </svg>
)
export const TopFeatures = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.087 11.459s-5.057 0-5.543-8.77C7.057 11.459 2 11.459 2 11.459s5.057 0 5.544 8.77c.486-8.77 5.543-8.77 5.543-8.77Zm4.328-5.053s-2.541 0-2.786-4.406c-.244 4.406-2.785 4.406-2.785 4.406s2.54 0 2.785 4.406c.245-4.406 2.786-4.406 2.786-4.406Z"
        />
        <path
            opacity=".75"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 11.459s-2.54 0-2.785-4.406c-.245 4.406-2.785 4.406-2.785 4.406s2.54 0 2.785 4.406C19.459 11.459 22 11.459 22 11.459Z"
        />
        <path
            opacity=".5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.415 16.92s-2.541 0-2.786-4.406c-.244 4.406-2.785 4.406-2.785 4.406s2.54 0 2.785 4.406c.245-4.406 2.786-4.406 2.786-4.406Z"
        />
    </svg>
)
export const UserPermissions = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path opacity=".6" d="M14.3 5.7c0-.8-.64-1.44-1.44-1.44h-1.72c-.8 0-1.44.64-1.44 1.44v.84h4.6V5.7Z" />
        <path d="M19.56 7.52H4.44c-1.06 0-1.94.88-1.94 1.94v8.32c0 1.06.88 1.94 1.94 1.94h15.12c1.06 0 1.94-.88 1.94-1.94V9.46c0-1.08-.88-1.94-1.94-1.94ZM8 10.06a1.72 1.72 0 0 1 0 3.44c-.96 0-1.72-.76-1.72-1.72 0-.94.76-1.72 1.72-1.72ZM5.32 16.4c0-1.18.44-2.22 1.12-2.86.421.36.96.6 1.56.6.6 0 1.14-.22 1.561-.6.68.64 1.12 1.68 1.12 2.86-.02 1.04-5.36 1.04-5.36 0Zm13.02.64H13.1c-.26 0-.48-.22-.48-.48s.22-.48.48-.48h5.24c.26 0 .48.22.48.48s-.2.48-.48.48Zm0-2.94H13.1c-.26 0-.48-.22-.48-.48s.22-.48.48-.48h5.24c.26 0 .48.221.48.48 0 .26-.2.48-.48.48Zm0-2.92H13.1c-.26 0-.48-.22-.48-.48s.22-.48.48-.48h5.24c.26 0 .48.22.48.48s-.2.48-.48.48Z" />
    </svg>
)
export const UTM = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.25 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h17.5a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H3.25Zm3.002 8.064c1.328 0 2.248-.712 2.248-2.144V9.4H7.324v3.512c0 .728-.448 1.056-1.072 1.056-.624 0-1.072-.328-1.072-1.056V9.4H4.004v3.52c0 1.432.92 2.144 2.248 2.144ZM10.768 15h1.264v-4.52h1.64V9.4H9.12v1.08h1.648V15Zm4.693 0h-1.176V9.4h1.392l1.624 3.808L18.925 9.4h1.392V15h-1.176v-3.256L17.765 15h-.92l-1.384-3.256V15Z"
        />
    </svg>
)
export const WebPerformance = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M5.962 9.858v7.503c0 1.381 1.152 2.494 2.602 2.494h6.85c1.281 0 2.33-.87 2.557-2.024 0-.004 0-.007.002-.01a2.507 2.507 0 0 0 .044-.46v-.746a.229.229 0 0 1-.016-.086V12.11v.001c0-.03.005-.058.016-.086V9.858H5.962ZM18.466 11v.885h2.064a.222.222 0 0 1 .224.224v4.419c0 .059-.023.116-.065.158a.225.225 0 0 1-.159.066h-2.064v.608c0 .094-.005.186-.015.277h1.747c.732 0 1.316-.588 1.316-1.329v-3.98c0-.74-.584-1.329-1.316-1.329h-1.732Zm-1.481 3.201a.22.22 0 0 1 .162.065.228.228 0 0 1 .066.162v.773a.225.225 0 1 1-.45 0v-.773a.224.224 0 0 1 .222-.227Zm0 1.548v-.001c.06-.001.118.023.162.066a.228.228 0 0 1 .066.16v.775c0 .341-.072.667-.202.962-.13.296-.318.561-.55.784a2.567 2.567 0 0 1-.812.524 2.647 2.647 0 0 1-.993.192.226.226 0 0 1-.23-.224.225.225 0 0 1 .23-.224c.295 0 .573-.057.826-.159.253-.102.48-.25.67-.432.19-.183.342-.4.448-.64.105-.24.164-.504.164-.782v-.775a.224.224 0 0 1 .22-.226ZM2 20.328c.055.061.117.124.223.193.255.166.644.329 1.11.466.933.272 2.176.444 3.351.444h10.72c1.265 0 2.48-.172 3.36-.443.441-.135.797-.297 1.027-.461.099-.07.159-.135.209-.197l-20-.002Zm5.288 1.553a.825.825 0 0 0-.8.621h11.004a.827.827 0 0 0-.8-.621H7.287Z" />
        <path
            opacity=".5"
            d="M7.974 2a.225.225 0 0 0-.23.224.224.224 0 0 0 .23.224c.394 0 .819.163 1.03.448.209.285.269.712-.148 1.412l-.889 1.495c-.478.804-.404 1.54-.064 2.038.34.498.904.774 1.411.774a.224.224 0 0 0 0-.448c-.333 0-.792-.213-1.04-.578-.25-.364-.332-.864.079-1.555l.889-1.495c.472-.795.447-1.468.122-1.908-.324-.44-.88-.63-1.39-.63Zm3.56 0a.226.226 0 0 0-.23.224.224.224 0 0 0 .23.224c.393 0 .818.163 1.029.448.21.285.27.712-.147 1.412l-.89 1.495c-.477.804-.404 1.54-.064 2.038.34.498.904.774 1.412.774a.224.224 0 0 0 0-.448c-.335 0-.793-.213-1.041-.578-.249-.364-.332-.864.08-1.555l.888-1.495c.473-.795.447-1.468.122-1.908-.324-.44-.88-.63-1.39-.63Zm3.188 0a.225.225 0 1 0 0 .448c.393 0 .819.163 1.028.448.21.285.27.712-.146 1.412l-.89 1.495c-.478.804-.404 1.54-.064 2.038.34.498.904.774 1.411.774h.001a.224.224 0 0 0 0-.448c-.334 0-.792-.213-1.042-.578-.248-.364-.33-.864.08-1.555l.889-1.495c.472-.795.447-1.468.123-1.908-.325-.44-.88-.63-1.39-.63Z"
        />
    </svg>
)
export const HogQL = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${className}`}
        {...other}
    >
        <path d="M12 22h-1.25V2H12v20Zm-8.75-2.5v-15c0-.345.28-.625.625-.625h6.875c.345 0 .625.28.625.625v15c0 .345-.28.625-.625.625H3.875a.625.625 0 0 1-.625-.625Zm2.5-13.125a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0Zm0 1.875a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0Zm-1.25 10h5.625V17H4.5v1.25Zm0-2.5h5.625V14.5H4.5v1.25Zm0-2.5h5.625V12H4.5v1.25Z" />
        <path opacity=".6" d="M14.5 5.125v5h5v-5h-5Zm6.25-1.25v7.5h-7.5v-7.5h7.5Z" />
        <path
            opacity=".7"
            d="M12.625 13.75h-1.25v-1.25h1.25v1.25Zm0-2.5h-1.25v-1.25h1.25v1.25Zm0-2.5h-1.25V7.5h1.25v1.25Zm7.5 7.5h-6.25v-1.25h6.25v1.25Zm0-2.5h-6.25v-1.25h6.25v1.25Zm0-2.5h-6.25v-1.25h6.25v1.25Z"
        />
    </svg>
)
export const Annotation = ({ className = '', ...other }: { className?: string }): JSX.Element => (
    <svg
        width="26"
        height="30"
        viewBox="0 0 26 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`fill-current ${className}`}
        {...other}
    >
        <path
            d="M13.0044 1.125V28.875M0.988281 8.0625L25.0205 21.9375M0.989735 21.9375L25.0219 8.0625"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)
